module.exports = __webpack_public_path__ + "static/media/plate3Img1.392de6ab.png";